import {
	IconProductHydrogen,
	IconSliders,
	IconSync,
	IconPersonChecked,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Permissions overview',
		link: '/tools/permissions-overview',
		icon: <IconSliders />,
	},
	{
		type: 'Clickable',
		text: 'Unused subscriptions',
		link: '/tools/unused-subscriptions',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'SSO Form tracking state generator',
		link: '/tools/tracking-state-generator',
		icon: <IconProductHydrogen />,
	},
	{
		type: 'Clickable',
		text: 'Primary account tool',
		link: '/tools/primary-accounts',
		icon: <IconPersonChecked />,
	},
];

export default menuConfig;
